import { isNodeV2 } from '@vedalib/editor'
import * as R from 'ramda'

import { getParentNode } from 'components/Editor/EditorContext/selectors/block'
import { updateBlock } from 'services/Store/Project/actions'
import { toggleHidden } from 'services/Store/Project/mutators/node'
import {
  getBlock,
  getDeviceMode,
  getSelectedNodeIds,
  mergeNodeStyle,
} from 'services/Store/Project/selectors'
import type { Block } from 'services/Store/Project/types'
import store from 'services/Store/store'

export const onHide = () => {
  const dispatch = store.dispatch
  const state = store.getState().project
  const block = getBlock(state)
  const selectedNodes = getSelectedNodeIds(state)
  const device = getDeviceMode(state)
  const children = selectedNodes
    .map((id) => block?.schema.nodes[id])
    .filter(isNodeV2)
    .filter((node) => {
      const isItem = getParentNode(node.id, block)?.elementId
      return !isItem
    })

  if (block) {
    dispatch(
      updateBlock({
        id: block?.uuid,
        value: R.compose(
          ...(children.map((node) =>
            toggleHidden(node, device, !mergeNodeStyle(node.style, device)?.hidden),
          ) as [(block: Block) => Block]),
        )(block),
      }),
    )
  }
}
